export const teamMemberContainerSx = {
  display: 'flex',
  flexFlow: 'row wrap',
  marginTop: '24px',
};
